<template>
  <div class="profire_box">
    <el-scrollbar style="height: calc(100vh - 144px)" ref="scrollbar">
      <div v-if="show_flage == 1" class="minddle_box">
        <div class="out_box">Company profie</div>
            <div class="inner_title">Organization ID</div>
            <div class="inner_mes">{{profileDetial.organization_number}}</div>
            <div class="inner_title">Business Name (Short)</div>
            <div class="inner_mes">{{profileDetial.business_name}}</div>
            <div class="inner_title">Legal Company Name</div>
            <div class="inner_mes">{{profileDetial.legal_company_name}}</div>
          <div class="inner_title">Registered address</div>
          <div class="inner_mes">{{profileDetial.address}},{{profileDetial.city}},{{profileDetial.province}} {{profileDetial.postcode}}</div>
          <div class="inner_title">GST/HST number</div>
          <div class="inner_mes">{{profileDetial.gst_hst_number}}</div>
          <div class="inner_title">Phone number</div>
          <div class="inner_mes">+{{profileDetial.phone_code}}{{profileDetial.phone}}</div>
          <div class="inner_title">Email</div>
          <div class="inner_mes">{{profileDetial.email}}</div>
        <div style="display: flex">
          <div>
            <div class="inner_title">Rate per task</div>
            <div class="inner_mes">N/A</div>
          </div>
          <div  style="margin-left: 24px">
            <div class="inner_title">Billing Cycle</div>
            <div class="inner_mes">N/A</div>
          </div>
          <div  style="margin-left: 24px">
            <div class="inner_title">GST/HST rate in </div>
            <div class="inner_mes">N/A</div>
          </div>
          <div  style="margin-left: 24px">
            <div class="inner_title">Amounts are</div>
            <div class="inner_mes">N/A</div>
          </div>
        </div>
      </div>
      <div v-if="show_flage == 2" class="middle_box" style="width: 500px;margin: 0 auto">
        <el-form :model="comProfilForm"
                 ref="comForm"
                 label-width="100px"
                 class="demo-ruleForm"
                 label-position="top"
                 :rules="comRules"
                 :status-icon="true" :show-message="false">
          <div class="topTask">
            <el-form-item label=" Rate per task" required prop="rate_per_task">
              <el-input v-model="comProfilForm.rate_per_task" placeholder="rate" @input="handleInput"></el-input>
            </el-form-item>
            <el-form-item label="Billing Cycle" required >
              <el-select v-model="comProfilForm.billing_cycle" placeholder="placeholder">
                <el-option
                  v-for="item in bill_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" GST/HST rate in " required prop="rate_tax_id">
              <el-select v-model="comProfilForm.rate_tax_id" placeholder="Select the province the organization is located in">
                <el-option
                  v-for="item in rate_options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" Amounts are" required>
              <el-select v-model="comProfilForm.price_tax_status" placeholder="placeholder">
                <el-option
                  v-for="item in price_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div v-if="show_flage == 3" class="middle_box" style="width: 500px;margin: 0 auto">
        <div class="out_box">Primary Store Account</div>
        <div class="inner_title">Username</div>
        <div class="inner_mes">{{profileDetial.username}}</div>
        <div class="inner_title">Store  address</div>
        <div class="inner_mes">{{profileDetial.store_address}},{{profileDetial.store_city}},{{profileDetial.store_province}} {{profileDetial.store_postcode}}</div>
        <el-form :model="comProfilForm"  ref="topForm" label-width="100px" class="demo-ruleForm" label-position="top" :status-icon="true" :show-message="false">
          <div class="topTask">
          </div>
        </el-form>
      </div>
    </el-scrollbar>
    <div class="footers">
      <div>
        <el-button type="success" @click="cancelAddOrg" class="changes">Back</el-button>
        <el-button type="success" @click="refuseHandle" class="changes" v-if="show_flage == 1">Refuse</el-button>
        <el-button @click="nextHandle" class="changeCreate" v-if="show_flage<3">Next</el-button>
        <el-button @click="completeHandle" class="changeCreate" v-if="show_flage== 3">Complete</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {agreeInvite, getRate, rejectInvite} from "@/api/inbox";
import {getGroupList} from "@/api/driver";

export default {
  name: "comProfire",
  props:{
    profileDetial:{
      default:{}
    }
  },
  data(){
    return{
      // rejectNote:'',
      // rejectDialog:false,
      bill_options:[
        {value:1,label:'weekly'},
        {value:2,label:'Biweekly'},
        {value:3,label:'Monthly'},
      ],
      price_options:[
        {value:1,label:'Exclusive'},
        {value:2,label:'Inclusive'},
        {value:3,label:'Out of scope'},
      ],
      rate_options:[],
      group_options:[],
      comRules:{
        rate_per_task: [
          { required: true, message: '', trigger: 'blur' }
        ],
        rate_tax_id: [
          { required: true, message: '', trigger: 'blur' }
        ]
      },
      comProfilForm:{
        rate_per_task:'',
        billing_cycle:1,
        rate_tax_id:'',
        price_tax_status:1,
      },
      show_flage:1,
    }
  },
  created() {
    getRate().then(res=>{
      this.rate_options = res.data
    })
    //获取 司机所属group getGroupList
    getGroupList({
        page:1,
        limit:'',
      }).then(res=>{
      this.group_options = res.data.data
    })
  },
  methods:{
    cancelAddOrg(){
      if (this.show_flage == 1){
        this.$emit('closeProfire')
      }else {
        this.show_flage--
      }
    },
    confirmAddOrg(){

    },
    refuseHandle(){
      // this.rejectDialog = true
      this.$emit('openReject')
    },

    nextHandle(){
      if (this.show_flage == 2){
        if (this.validateForm()){
          this.show_flage++
        }else {
          this.$message({
            type:"warning",
            message:'Some information missing'
          })
        }
      }else {
        this.show_flage++
      }
    },
    validateForm() {
      let flag = false
      this.$refs['comForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    completeHandle(){
      this.comProfilForm.id = this.profileDetial.id
      this.comProfilForm.remark = ''
      this.comProfilForm.rate_per_task = Number(this.comProfilForm.rate_per_task)
      agreeInvite(this.comProfilForm).then(res=>{
        if (res.code == 200){
          this.show_flage = 1
          this.$emit('closeProfire')
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      }).catch(err=>{
        this.$message({
          type:'error',
          message:err.msg
        })
      })
    },
    handleInput(event) {
      // 只保留数字和小数点
      let newValue = event.replace(/[^\d.]/g, '');
      // 最多保留两位小数
      newValue = newValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      // 更新数据模型
      this.comProfilForm.rate_per_task = newValue;
    }
  }
}
</script>

<style scoped lang="less">
.profire_box{
  padding-top: 56px;
  margin-left: 8px;
  /deep/.el-scrollbar__wrap{
    overflow: auto;
  }
  .out_box{
    font-weight: bold;
    font-size: 24px;
    color: #1F2D42;
    line-height: 20px;
    margin-bottom: 24px;
  }
  .inner_title{
    margin: 16px 0;
    font-weight: bold;
    font-size: 14px;
    color: #1F2D42;
    line-height: 20px;
  }
  .inner_mes{
    margin: 16px 0;
    font-size: 14px;
    color: #1F2D42;
    line-height: 20px;
  }
  .minddle_box{
    color: #1F2D42;
    width: 500px;
    margin:0 auto;
  }
  .footers {
    width: calc(100% - 72px);
    z-index: 1;
    height: 64px;
    background: #1F2D42;
    position: fixed;
    bottom: 0;
    margin-left: -32px;
    line-height: 64px;
    display: flex;
    flex-direction: row-reverse;
    padding-right: 48px;
    padding-left: 32px;
    color: #FFFFFF;

    .changeCreate {
      color: #1F2D42;
    }
    .changeCreate:focus{
      border-color: #FFFFFF;
      background-color: #FFFFFF;
    }
    .changes{
      border: 1px solid #FFFFFF!important;
    }
    .changeCreate:hover {
      border-radius: 16px;
      border: 1px solid #FFFFFF;
      background: #1F2D42;
      color: #FFFFFF;
    }
  }
  }
/deep/.el-dialog__title{
  font-weight: bold;
}
</style>
